import t from "./common/localization";
import React from "react";
import DialogBox from "./DialogBox";

const SuccessDialog = ({ open, onResult, alertProps, closeDialogShown }) => {
  const onConfirm = () => {
    (alertProps.success && onResult(false)) || closeDialogShown();
  };
  return (
    <DialogBox
      sweetAlertProps={{
        // showCancel: true,
        show: open, // must have prop
        onConfirm: onConfirm,
        showCancel: false,
        confirmBtnText: t("ok"),
        confirmBtnStyle: {
          fontSize: "16px",
          color: "white",
          borderRadius: "10px",
          backgroundColor: "#22B410",
          boxShadow: "0 3px 5px 2px rgba(33, 203, 243, .3)",
          width: "100px",
          textAlign: "center",
          verticalAlign: "center",
          textDecoration: "",
          padding: "6px 0",
        },
        ...alertProps,
      }}
    >
      {alertProps.message}
      {/* Children custom html here */}
    </DialogBox>
  );
};

export default SuccessDialog;
